import audioPrevious from '../../../../../assets/svgs/app/audio/audioPrevious'

export default () => audioPrevious
